import { Events, animateScroll } from "react-scroll";

import { OUTBOUND_LCF, RETURN_LCF } from "@app/constants/seat-selection-first";

import type { NavigationState } from "../../hooks/use-navigation";
import type { History } from "history";

import {
  OPEN_DRAWER_KEY,
  VIEW_KEY,
  SEGMENT_ID_KEY,
  TRIP_ID_KEY,
  CART_ID_KEY,
  SELECTED_LEG_CARD_ID_KEY,
  SELECTED_SEATS_KEY
} from "./constants";
import { PAGES } from "../../constants/pages";

export class AsyncCartView {
  public static goTo(
    searchParams: URLSearchParams | string,
    is_mobile: boolean,
    trip_id: string,
    history: History<NavigationState>
  ) {
    const _searchParams = new URLSearchParams(searchParams);

    // segment_id is used to determine which segment should be displayed in the seat selection. When user reach the async cart page, we don't want the user go back to the seat selection page. We don't want any drawer opened when the user reach the async cart page.
    _searchParams.delete(OPEN_DRAWER_KEY);
    _searchParams.delete(SEGMENT_ID_KEY);

    _searchParams.set(VIEW_KEY, PAGES.ASYNC_CART);
    _searchParams.set(TRIP_ID_KEY, trip_id);

    Events.scrollEvent.register("end", () => {
      Events.scrollEvent.remove("end");
      history.push({
        search: _searchParams.toString()
      });
    });

    if (is_mobile) {
      const TIME_TO_TICKET_OPTIONS_DRAWER_CLOSE = 350;
      let SCROLL_TO_TOP_MOBILE_DURATION = 200;

      const SCROLL_Y = window && window.scrollY;
      SCROLL_TO_TOP_MOBILE_DURATION = Math.min(
        Math.max(SCROLL_Y, SCROLL_TO_TOP_MOBILE_DURATION),
        750
      );

      setTimeout(() => {
        animateScroll.scrollToTop({
          duration: SCROLL_TO_TOP_MOBILE_DURATION
        });
      }, TIME_TO_TICKET_OPTIONS_DRAWER_CLOSE);
    } else {
      animateScroll.scrollToTop({
        duration: 300
      });
    }
  }

  public static isCurrentlyViewed(searchParams: URLSearchParams) {
    return searchParams.get(VIEW_KEY) === PAGES.ASYNC_CART;
  }

  public static setCartId(
    search_params: URLSearchParams,
    history: History<NavigationState>,
    cart_id: string
  ) {
    search_params.set(CART_ID_KEY, cart_id);

    const keys_to_remove = [
      OPEN_DRAWER_KEY,
      SEGMENT_ID_KEY,
      SELECTED_LEG_CARD_ID_KEY,
      OUTBOUND_LCF,
      RETURN_LCF,
      TRIP_ID_KEY,
      SELECTED_SEATS_KEY
    ];

    keys_to_remove.forEach(key => search_params.delete(key));

    history.replace({
      search: search_params.toString()
    });
  }
}
